import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Toolbar,
  Typography,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { search_blue_icon } from "../../assets";

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 320 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

UserListToolbarsForSearch.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

export default function UserListToolbarsForSearch({
  numSelected,
  filterName,
  onFilterName,
  handleSubmit,
  buttonText,
}) {
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <form onSubmit={handleSubmit} className="custome-table-form">
          <div className="custom-input-design">
            {/* <SearchStyle
            sx={{ height: "45px" }}
            className="ms-auto"
            value={filterName}
            onChange={onFilterName}
            placeholder="Search "
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 21 }} />
              </InputAdornment>
            }
          /> */}
            <div className="position-relative">
              <input
                className="ps-5"
                placeholder={"Search..."}
                value={filterName}
                onChange={onFilterName}
              />

              <img
                src={search_blue_icon}
                className="input-start-icon"
                alt=""
              />
            </div>
          </div>
          {buttonText ? (
            ""
          ) : (
            <button className="small-button-cotain-view-all ms-3">Search</button>
          )}
        </form>
      )}

      {/* {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <Icon icon={roundFilterList} />
          </IconButton>
        </Tooltip>
      )} */}
    </RootStyle>
  );
}
